import { render } from "./ErrorView.vue?vue&type=template&id=b279d140&ts=true"
import script from "./ErrorView.vue?vue&type=script&lang=ts"
export * from "./ErrorView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\luke\\Desktop\\Bod_registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__